'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'building-shield';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4d8';
var svgPathData = 'M352 32L96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l64 0 0-80c0-26.5 21.5-48 48-48l32 0 0 4.4c0 9.3 .5 18.5 1.6 27.7-.5-.1-1.1-.1-1.6-.1l-32 0c-8.8 0-16 7.2-16 16l0 80 82.3 0c6.8 11.3 14.5 22 23 32L96 512c-35.3 0-64-28.7-64-64L32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 145.6c-3.1 .6-6.2 1.5-9.3 2.5L384 219.7 384 64c0-17.7-14.3-32-32-32zM304 246.3l-9.3 3.1c-12.3 4.1-23.1 11-31.7 19.8-4.2-2.9-7-7.7-7-13.2l0-16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 6.3zM272 112l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm-112 0l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zM144 240c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm176 87.2l0 31.1c0 62 35.8 118.4 91.9 144.8l4.1 1.9 0-209.8-96 32zM432 512.1c.3 0 .6 0 .8-.1l-1.7 0c.3 .1 .6 .1 .8 .1zm20.1-9.1c56.1-26.4 91.9-82.8 91.9-144.8l0-31.1-96-32 0 209.8 4.1-1.9zm-35.4 37.7L398.2 532C331 500.3 288 432.6 288 358.2l0-31.1c0-13.8 8.8-26 21.9-30.4l112-37.3c6.6-2.2 13.7-2.2 20.2 0l112 37.3c13.1 4.4 21.9 16.6 21.9 30.4l0 31.1c0 74.4-43 142.1-110.2 173.7l-18.5 8.7c-4.8 2.2-10 3.4-15.2 3.4s-10.5-1.2-15.2-3.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBuildingShield = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;